// extracted by mini-css-extract-plugin
module.exports = {"tagsInformation":"TagsInformation_tagsInformation__XTkMb","title":"TagsInformation_title__3JY4l","tags":"TagsInformation_tags__3Y4Wh","chips":"TagsInformation_chips__2pyps"};